import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from 'react-toastify';
import React, { useEffect } from 'react';
import './App.css';
import Login from '../login';
import { ProfileHome, EditProfile, PublicProfile } from '../profile';
import { AuthProvider } from './AuthContext';
import SecureRoute from './SecureRoute';
import NotLoggedRoute from './NotLoggedRoute';
import 'react-toastify/dist/ReactToastify.css';
import Toaster from '../toaster';
import UserValidation from '../uservalidation';
import ResetForgotPassword from '../ResetforgotPassword';
import PublicUserReviewList from '../profile/review-list-view';
import ForgotPassword from '../forgotpassword';
import Chat from '../chat';
import {
  AssetSearchPage,
  ViewUserAssetDetailPage,
  ViewUserAssetPage,
} from '../assets';
import { ContactUsPage } from '../contactus/ContactUsPage';
import { DiscoveryPage } from '../discovery/DiscoveryPage';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { TermsAndConditions } from '../policies/TermsAndConditions';
import { isLocalhost } from '../../serviceWorker';
import TypeFormCreateAccount from '../home/TypeFormCreateAccount';
import { PrivacyPolicy } from '../policies/PrivacyPolicy';

function App() {
  useEffect(() => {
    if (!isLocalhost && window.location.protocol !== 'https:') {
      window.location.replace(window.location.href.replace('http:', 'https:'));
    }
  }, []);

  return (
    <AuthProvider>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Router>
          <Switch>
            <SecureRoute
              path="/signup"
              component={Login}
              pageTitle="Sign up"
              openToPublic={true}
            />
            <NotLoggedRoute
              path="/login"
              component={Login}
              pageTitle="Log in"
              openToPublic={true}
            />
            <NotLoggedRoute
              path="/create_account"
              component={TypeFormCreateAccount}
              pageTitle="Sign up success"
            />
            <NotLoggedRoute
              path="/validation/newaccount/:token"
              component={UserValidation}
              pageTitle="User validation"
            />
            <NotLoggedRoute
              path="/forgotpassword"
              component={ForgotPassword}
              pageTitle="Forgot password"
            />
            <SecureRoute
              path="/terms-and-conditions"
              component={TermsAndConditions}
              pageTitle="Terms and condition"
              openToPublic={true}
            />
            <SecureRoute
              path="/privacy-policy"
              component={PrivacyPolicy}
              pageTitle="Privacy Policy"
              openToPublic={true}
            />
            <NotLoggedRoute
              path="/validation/forgotpassword/:token"
              component={ResetForgotPassword}
              pageTitle="Reset password"
            />
            <SecureRoute
              path="/contact-us"
              component={ContactUsPage}
              pageTitle="Contact us"
              openToPublic={true}
            />
            <SecureRoute
              path="/search"
              component={AssetSearchPage}
              pageTitle="Search"
              openToPublic={true}
            />
            <SecureRoute
              exact
              path="/profile"
              component={ProfileHome}
              pageTitle="User profile"
            />
            <SecureRoute
              exact
              path="/profile/edit"
              component={EditProfile}
              pageTitle="Edit profile"
            />
            <SecureRoute
              exact
              path="/profile/:username/reviews"
              component={PublicUserReviewList}
              pageTitle="User reviews"
            />
            <SecureRoute
              path="/profile/:username"
              component={PublicProfile}
              pageTitle="Public profile"
              openToPublic={true}
            />
            <SecureRoute
              path="/offerings/:id"
              component={ViewUserAssetDetailPage}
              openToPublic={true}
              pageTitle="Offering details"
            />
            <SecureRoute
              path="/assets/:id"
              component={ViewUserAssetDetailPage}
              openToPublic={true}
              pageTitle="Offering details"
            />
            <SecureRoute
              path="/my-offerings"
              component={ViewUserAssetPage}
              pageTitle="My Offerings"
            />
            <SecureRoute
              path="/user-offerings/:id"
              component={ViewUserAssetPage}
              openToPublic={true}
              pageTitle="User Offerings"
            />
            <SecureRoute
              exact
              path="/chat"
              component={Chat}
              pageTitle="Chat list"
            />
            <SecureRoute
              path="/chat/:serialId"
              component={Chat}
              pageTitle="Chatroom"
            />
            <SecureRoute
              exact
              path="/offerings"
              component={ViewUserAssetPage}
              pageTitle="Offerings"
            />
            <SecureRoute
              path="/discovery"
              component={DiscoveryPage}
              pageTitle="Discovery"
            />
            <SecureRoute
              path="/"
              component={AssetSearchPage}
              pageTitle="Search"
              openToPublic={true}
            />
            <Redirect from="/assets/:id" to="/offerings/:id" />
            <Redirect from="/my-assets" to="/my-offerings" />
            <Redirect from="/user-assets/:id" to="/user-offerings/:id" />
            <Redirect from="/assets" to="/user-offerings" />
            <Redirect from="/asset/:id" to="/offering/:id" />
            <Redirect from="/user-suap-wallet" to="/user-offerings" />
            <Redirect from="/user-suap-wallet/:id" to="/user-offerings/:id" />
            <Redirect from="/suap-wallet" to="/my-offerings" />
            <Redirect from="/suap-wallet/:id" to="/my-offerings/:id" />
          </Switch>
          <Toaster />
        </Router>
        <ToastContainer hideProgressBar={true} />
      </LocalizationProvider>
    </AuthProvider>
  );
}

export default App;
